import api from '../api/posts'

const state = {
    posts: false,
    post: false,
}

const getters = {
    getPosts: state => {
        return state.posts
    },
    getPost: state => {
        return state.post
    }
}

const actions = {
    getPosts({dispatch, commit}) {
        return new Promise((resolve, reject) => {
            api.getPosts()
            .then((success) => {
                commit('setPosts', success.items)
                return resolve(success)
            }).catch((failed) => {
                commit('setPosts', false)
                return reject(failed)
            })
        })
    },
    getPost({dispatch, commit}, slug) {
        return new Promise((resolve, reject) => {
            api.getPost(slug)
            .then((success) => {
                commit('setPost', success.items[0])
                return resolve(success)
            }).catch((failed) => {
                commit('setPost', false)
                return reject(failed)
            })
        })
    }
}

const mutations = {
    setPosts(state, value) {
        state.posts = value.sort((a, b) => {
            if (Date.parse(a.fields.publishDate) > Date.parse(b.fields.publishDate)) {
                return 1
            } else if (Date.parse(a.fields.publishDate) < Date.parse(b.fields.publishDate)) {
                return -1
            } else {
                return 0
            }
        })
    },
    setPost(state, value) {
        state.post = value
    },
}
export default {
    state, getters, actions, mutations
}
